import type { ReactNode } from "react";

type SharedCtaAction = {
  href: string;
  label: string;
  icon?: string;
  variant?: "primary" | "secondary";
};

export function SharedCta({
  title,
  copy,
  actions,
  className = ""
}: {
  title: ReactNode;
  copy: ReactNode;
  actions: SharedCtaAction[];
  className?: string;
}) {
  return (
    <section className={`shared-cta ${className}`}>
      <div className="shared-cta-content">
        <h2>{title}</h2>
        <p>{copy}</p>
        <div className="shared-cta-actions">
          {actions.map((action) => (
            <a className={action.variant === "secondary" ? "shared-cta-button shared-cta-button-secondary" : "shared-cta-button shared-cta-button-primary"} href={action.href} key={action.label}>
              {action.icon ? <span className="material-symbols-outlined">{action.icon}</span> : null}
              {action.label}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
